import { Parameter } from "domain/entities/parameter";
import { translateText } from "infra/translation/translate";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import React from "react";
import styles from "../index.module.css";

interface ParamProps {
  fieldName: string;
  options: Parameter[];
  label: string;
  isValueId?: boolean;
  fieldNameId?: string;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  showClear?: boolean;
  replaceArray?: { from: string; to: any }[];
  getValue: string | undefined | null | any;
  setValue: (updatedObject: any) => void;
}

const MobileDropdownComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: DropdownChangeEvent) => {
    let selectedOption = e.value;

    if (selectedOption === null) {
      const updatedObject = {
        ...params.currentObject,
        [params.fieldName]: null,
      };
      params.setValue(updatedObject);
      return;
    }

    if (params.isValueId && (!params.fieldNameId || params.fieldName == "id")) {
      const currentOption = params.options.find((item) => item.id === e.value);
      selectedOption = currentOption ? { id: currentOption.id } : null;
    } else if (
      params.isValueId &&
      params.fieldNameId &&
      params.fieldName !== "id"
    ) {
      const currentOption = params.options.find((item) => item.id === e.value);
      selectedOption = currentOption ? currentOption.id : null;
    }

    if (params.replaceArray) {
      const replacement = params.replaceArray.find(
        (item) => item.from === e.value
      );
      if (replacement) {
        selectedOption = replacement.to;
      }
    }

    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: selectedOption,
    };

    params.setValue(updatedObject);
  };

  return (
    <Dropdown
    inputId={params.fieldName}
    className="w-full"
    options={params.options}
    optionLabel="value"
    optionValue={params.isValueId ? "id" : "value"}
    placeholder={params.label}
    value={params.getValue ?? null}
    onChange={handleChange}
    disabled={params.isDisable || false}
    invalid={params.isInvalid || false}
    filter
    filterBy="value"
    showClear={params.showClear || false}
    />
  );
};

export default MobileDropdownComponent;
